var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAnimatingFish)?_c('LottieAnimation',{ref:"anim",staticClass:"jumping-fish",attrs:{"animation-data":_vm.jumpingFishAnimationData,"auto-play":true,"loop":true,"speed":1},on:{"loopComplete":_vm.completeFishAnimation}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }